<template>
	<div class="row content-block">
		<div class="content-info w-100">
			<div class="col-12 col-lg-12" v-html="content" />
			<div class="col-12 col-lg-12 sticky-container">
				<div v-for="(item) in entities.content" v-if="item" class="mb-4">
					<div class="event_brief_image theme-light">
						<div class="bg-event" :style="'background-image:url(' + item.listing_cover_image_url_facebook || '' + ')'">
							<div class="event-title mb-4">
								{{ item.taxonomy_type_title }}
							</div>
							<div class="event-title">
								<nuxt-link :to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)">
									<h4 class="title"> {{ item.title }} </h4>
								</nuxt-link>
							</div>
							<div class="mt-3">
								<nuxt-link :to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)" class="more_link">
									{{ $t('more') }}
								</nuxt-link>
							</div>
						</div>
					</div>
				</div>
				<div v-for="(item) in entities.event" v-if="item" >
				  <div class="event_brief_image theme-light">
				    <div class="bg-event"
				       :style="'background-image:url(' + item.top_cover_image_url_default + ')'"
				    >
				      <div class="event_date">
				        <span>
				          {{ item.event_date | moment("DD") }}
				        </span>
				        <!-- Это кнопка "Добавить в календарь" с tooltip-подсказкой
				        <a :href="'http://sk.dreamdigital.ru/api/calendar/event/' + item.id +'/'" class="add_announce" v-b-tooltip.hover.top="'Добавить в календарь'"></a> -->
				      </div>
				      <div class="event_month">
				        {{ item.event_date | moment("MMMM") }}
				      </div>
				      <div class="event-title">
				        <nuxt-link :to="$url.event(item.slug, item.typology_slug)">
				          <h4 class="title mb-0">
				            {{ item.title }}
				          </h4>
				        </nuxt-link>
				      </div>
				      <div class="mt-3">
				        <nuxt-link :to="$url.event(item.slug, item.typology_slug)" class="more_link">
				          {{ $t('more') }}
				        </nuxt-link>
				      </div>
				    </div>
				  </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';

export default {
	name: 'WysiwygWithEntities',
	props: [
		'entities',
		'event',
		'content',
	],
};
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/components/home/panel-explist';
  @import '~/assets/styles/components/home/panel-about_program';
</style>
